import React from 'react';
import { Box, BoxProps } from '@mui/material';
import VeilStreamLogo from './VeilStreamLogo';
import EnvironmentsText from './EnvironmentsText';

interface ProductTitleProps extends Omit<BoxProps, 'component'> {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  centered?: boolean;
  showText?: boolean;
  textVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  layout?: 'vertical' | 'horizontal';
}

const ProductTitle: React.FC<ProductTitleProps> = ({
  size = 'medium',
  centered = true,
  showText = false,
  textVariant = 'h3',
  layout = 'vertical',
  sx,
  ...props
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: layout === 'horizontal' ? 'row' : 'column',
        alignItems: layout === 'horizontal' ? 'center' : 'center',
        justifyContent: centered ? 'center' : 'flex-start',
        gap: layout === 'horizontal' ? 2 : 1,
        ...sx
      }}
      {...props}
    >
      <VeilStreamLogo size={size} />
      {showText && <EnvironmentsText size={size} />}
    </Box>
  );
};

export default ProductTitle;
